/**
 * Class for getMobileManifest api
 */
export default class StreamManifestModel {
    /**
     * Class constructor method
     */
    constructor({
        surl = null,
        st = 1,
        ecd = 0,
        ems = '',
        tstamp = 0,
    }) {
        /**
         * Stream url
         * @type {string}
         */
        this.streamUrl = surl;
        /**
         * Stream type
         * @type {1|2|3|4}
         */
        this.streamType = st;
        /**
         * Error code
         * @type {number}
         */
        this.errorCode = ecd;
        /**
         * Error message
         * @type {string}
         */
        this.errorMsg = ems;
        /**
         * Auth token timestamp
         * @type {number}
         */
        this.timestamp = tstamp;
    }
}
